<template>
  <b-modal :id="id"
           lazy
           centered
           ok-variant="ls"
           size="lg"
           :title="$t('Install app')"
           :cancel-title="$t('Dont show again')"
           footer-class="justify-content-between"
           :ok-title="okTitle"
           @cancel="neverShowAgain"
           @ok="install"
           hide-header
           no-stacking
  >
    <div class="d-flex justify-content-center mt-2">
      <div class="icon">
        <div class="logo d-flex text-center">
          <img :src="icon" :alt="title">
        </div>
      </div>
    </div>
    <div class="p-3 text-center mt-1">
      <h3>{{$t('Install app')}} {{ title }}</h3>
      <p>{{$t('Add app to home screen')}}</p>
    </div>
    <!--  iOS  -->
    <div v-if="isIphone" class="how-to">
      <ul>
        <li v-if="!isSafari">{{$t('Open Safari')}}</li>
        <li>{{$t('Press')}} <img class="ml-1" src="@/assets/iOS-share.jpeg" width="15" height="20" alt="" style="margin-top: -5px"></li>
        <li>{{$t('Next choose')}} <strong>{{$t('To start screen')}}</strong></li>
      </ul>
    </div>

    <div v-if="isAndroid && !beforeInstallEvent" class="how-to">
      <ul>
        <li>{{$t('Press')}} <img class="ml-1" src="@/assets/chrome-options.jpeg" width="15" height="20" alt="" style="margin-top: -2px"></li>
        <li v-if="isChrome">{{$t('Next choose')}}  <strong>{{$t('To start screen')}}</strong></li>
        <li v-if="isSamsungInternet">{{$t('Next choose')}} <strong>{{$t('Add to start screen')}}</strong></li>
        <li v-if="isFirefox">{{$t('Next choose')}} <strong>{{$t('Install')}}</strong></li>
        <li v-if="isOpera">{{$t('Next choose')}} <strong>{{$t('Main screen')}}</strong> {{$t('In adding section')}}</li>
      </ul>
    </div>
  </b-modal>
</template>

<script>
  import {mapState} from "vuex";
  export default {
    name: "InstallPwaModal",
    data() {
      return {
        id: 'install-pwa-modal',
        beforeInstallEvent: null,
        timeout: 3000,
        isOpen: false,
      }
    },
    mounted() {
      if (!this.isIphone && !this.isAndroid) {
        return false;
      }

      window.addEventListener('beforeinstallprompt', (e) => {
        e.preventDefault();
        this.beforeInstallEvent = e;
        this.showWithTimeout();
      });

      if (!this.isBrowserAllowed) {
        return false;
      }

      if (this.isAndroid && this.isChrome) {
        return false;
      }

      if (this.isPwa || this.isWebkit) {
        return false;
      }

      this.showWithTimeout();
    },
    methods: {
      neverShowAgain() {
        localStorage.setItem(this.dismissStorageKey, true);
      },
      install() {
        if (this.beforeInstallEvent) {
          this.$bvModal.hide(this.id);
          this.beforeInstallEvent.prompt();
        }
      },
      showWithTimeout() {
        if (this.dismissModal) {
          return false;
        }

        setTimeout(() => this.$bvModal.show(this.id), this.timeout);
      },
    },
    computed: {
      ...mapState({
        isPwa: state => state.browser.isPwa,
        isWebkit: state => state.browser.isWebkit,
        isIphone: state => state.browser.isIphone,
        isAndroid: state => state.browser.isAndroid,
        isChrome: state => state.browser.isChrome,
        isFirefox: state => state.browser.isFirefox,
        isOpera: state => state.browser.isOpera,
        isSafari: state => state.browser.isSafari,
        isSamsungInternet: state => state.browser.isSamsungInternet,
        isBrowserAllowed: state => state.browser.isBrowserAllowed,
        entityUuid: state => state.auth.entity.uuid,
        favicons: state => state.settings.favicons,
        title: state => state.settings.title,
      }),
      dismissStorageKey() {
        return `ls-dismiss-app-install-${this.entityUuid}`;
      },
      dismissModal() {
        return localStorage.getItem(this.dismissStorageKey) === 'true';
      },
      okTitle() {
        return this.beforeInstallEvent ? this.$t('Install') : this.$t('Close');
      },
      icon() {
        return this.favicons
          ? this.favicons['180']
          : `${process.env.VUE_APP_PUBLIC_PATH}/apple-touch-icon-180x180.png`;
      },

    }
  }
</script>

<style scoped>
  .icon {
    width: 120px;
    height: 120px;
    padding: 15px;
    background: #efefef;
    border-radius: 25px;
    display: flex;
    justify-items: center;
    align-items: center;
  }

  .logo img {
    width: 90px;
    height: auto;
    max-height: 90px;
  }

  .how-to {
    font-size: 15px;
  }
</style>
